import React, { useEffect, useRef, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import $ from "jquery";
import "jquery-ui/dist/jquery-ui.js";
import "jquery-ui/themes/base/all.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function ChallanContainer({ challanNo, setChallanNo }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const token = localStorage.getItem("token");
  const centcode = localStorage.getItem("CentCode");
  const iframeRef = useRef(null);
  const movetodashboard = (e) => {
    e.preventDefault();
    navigate("/dashboard");
  }
  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [navigate, token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${config.API_BASE_URL}/Auth/GetListGenerateChallan`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            cenT_CODE: centcode,
          }),
        });

        if (response.status !== 200) {
          Swal.fire({
            icon: "warning",
            title: "Data not found!",
          });
          setLoading(false);
          return; 
        }

        const result = await response.json();
        // console.log("Challan data:", result?.data?.school_data);

        setData(result?.data?.school_data ?? []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  useEffect(() => {
    if (data.length > 0) {
      const table = $(tableRef.current).DataTable({
        paging: false,
        info: false,
        destroy: true,
        columnDefs: [{ orderable: false, targets: 0 }],
      });

      return () => {
        table.destroy();
      };
    }
  }, [data]);

  const handleGenerateChallan = async () => {
    if (data.length === 0) return; // Prevent execution if no data

    const token = localStorage.getItem("token");
    const centreCode = localStorage.getItem("CentCode");

    if (!token || !centreCode) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "Missing authentication token or centre code!",
      });
      return;
    }
     const result = await Swal.fire({
          title: "Are you sure to generate the challan?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Generate!",
          cancelButtonText: "No, Cancel",
          reverseButtons: true,
        });
        if (!result.isConfirmed) {
          return;
        }
    setLoading(true); 
    const candidateIds = data.map((student) => student.CANDIDATE_ID).join(",");

    const payload = {
      candidatE_ID: candidateIds,
      centeR_CODE: centreCode,
    };
    console.log(payload);
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/Auth/GeneratedChallan`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Challan Generated Successfully:", response.data);
      const challanNo = response.data?.challan_no;

      if (challanNo) {
        setChallanNo(challanNo);
        openModal2(challanNo); // Open modal with the challan number
      } else {
        alert("Challan generated but no Challan Number found.");
      }

      // Reload the page after challan generation
      // window.location.reload();
    } catch (error) {
      console.error("Error generating challan:", error);
      alert("Failed to generate challan. Please try again.");
    }
    finally {
      setLoading(false); // Stop loader
    }
  };

  const openModal2 = (challanNo) => {
    localStorage.setItem("modalOpen", "true");
    $('#pdfModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
    const pdfUrl = `/generate-pdf/${challanNo}`;
    if (iframeRef.current) {
      iframeRef.current.src = pdfUrl;
    }

  };
  const closeModal2 = () => {
    $('#pdfModal').removeClass('show').css('display', 'none');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove(); // Remove the backdrop

    window.location.reload(); // Reload the page when the modal is closed
  };
  return (
    <div className="pc-container">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12 breadcrumb">
                <div className="page-header-title">
                  <h5 className="m-b-10">GENERATE CHALLAN</h5>
                </div>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><a href="" onClick={movetodashboard}>Home</a></li>
                  <li className="breadcrumb-item"><a href="">Generate Challan</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ padding: '0px' }}>
          <div className="col-md-12">
            <div className="card tbl-card" style={{ border: '1px solid #1890ff' }}>
              <div className="card-body padding-10">
                <div className="table-responsive">
                  <table ref={tableRef} className="table table-hover table-bordered mb-0">
                    <thead>
                      <tr className="table-info">
                        <th>Sl. No</th>
                        <th>Name of Candidate</th>
                        <th>Gender</th>
                        <th>Date of Birth</th>
                        <th>Father’s Name</th>
                        <th>Mother’s Name</th>
                        <th>Category</th>
                        <th>Registration No</th>
                        <th className="text-start">Registration Year</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((student, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <i className="fa fa-user text-primary"></i>&nbsp;
                              {student.CAND_NAME}
                              <input type="hidden" name={`candidate_id_${index}`} value={student.CANDIDATE_ID} />
                            </td>
                            <td>{student.GENDER_NAME}</td>
                            <td>{student.DOB}</td>
                            <td>{student.FATHERS_NAME}</td>
                            <td>{student.MOTHERS_NAME}</td>
                            <td>{student.CATEGORY_NAME}</td>
                            <td>{student.REGISTRATION_NUMBER}</td>
                            <td className="text-start">{student.REGISTRATION_YEAR}</td>
                          </tr>
                        ))
                      ) : null}
                    </tbody>

                    {data.length > 0 && (
                      <tfoot>
                        <tr>
                          <td colSpan={9}>
                            {/* <button 
                              className="btn btn-sm btn-success text-white"
                              onClick={handleGenerateChallan}
                            >
                              <i className="fa fa-print"></i>&nbsp;Generate Challan
                            </button> */}
                          
                            <span className="text-danger blink-text" style={{fontWeight:600}}>&nbsp;&nbsp;Generate Challan Closed</span>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>

                  {data.length === 0 && (
                    <div className="text-center text-danger mt-3">No data available</div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="pdfModal" role="dialog" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Challan PDF Preview</h5>
              <button type="button" className="btn-close" onClick={closeModal2}></button>
            </div>
            <div className="modal-body">
              <iframe ref={iframeRef} width="100%" height="500px" style={{ border: "none" }}></iframe>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal2}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default ChallanContainer;
